import i18n from "@/i18n";

export default {
  sitePatrolRecords: [
    {
      site: [
        { number: 1, label: "openingMeeting", result: null },
        { number: 2, label: "preStartStatus", result: null },
        { number: 3, label: "workClothes", result: null },
        { number: 4, label: "organize", result: null },
        { number: 5, label: "doorWays", result: null },
        { number: 6, label: "smokingRestArea", result: null },
        { number: 7, label: "hygieneStatus", result: null },
      ],
    },
    {
      site: [
        { number: 8, label: "fireUsageStatus", result: null },
        { number: 9, label: "safetySignStatus", result: null },
        { number: 10, label: "guardsArragement", result: null },
        { number: 11, label: "thirdPartyMeasures", result: null },
        { number: 12, label: "curingOpenings", result: null },
        { number: 13, label: "scaffoldInstallation", result: null },
        { number: 14, label: "usingLadders", result: null },
      ],
    },
    {
      site: [
        { number: 15, label: "protruding60cmLadder", result: null },
        { number: 16, label: "heightsWork", result: null },
        { number: 17, label: "flyingFallTreatment", result: null },
        { number: 18, label: "collapseTreatment", result: null },
        { number: 19, label: "craneStatus", result: null },
        { number: 20, label: "constructionMachineStatus", result: null },
        { number: 21, label: "commanderWorkStatus", result: null },
      ],
    },
    {
      site: [
        { number: 22, label: "personelWorkStatus", result: null },
        { number: 23, label: "temporaryElecticity", result: null },
        { number: 24, label: "dangerousMaterialStorage", result: null },
        { number: 25, label: "organicSolveStatus", result: null },
        { number: 26, label: "oxygenMeasure", result: null },
        { number: 27, label: "workDone", result: null, customLabel: null },
        { number: 28, label: "workRulesObserved", result: null, customLabel: null },
      ],
    },
  ],
  inspectionRecords: {
    inProcessFields: [
      {
        key: "point",
        label: i18n.tc("inspectionsTable.inProcessTable.subHeading.point"),
      },
      {
        key: "time",
        label: i18n.tc("inspectionsTable.inProcessTable.subHeading.time"),
      },
      {
        key: "inspector",
        label: i18n.tc("inspectionsTable.inProcessTable.subHeading.inspector"),
      },
      {
        key: "result",
        label: i18n.tc("inspectionsTable.inProcessTable.subHeading.result"),
      },
      {
        key: "informed",
        label: i18n.tc("inspectionsTable.inProcessTable.subHeading.informed"),
      },
      {
        key: "counterplan",
        label: i18n.tc(
          "inspectionsTable.inProcessTable.subHeading.counterplan"
        ),
      },
      {
        key: "binIcon",
        label: "",
      },
    ],
  },
  workRecords: {
    titleHeader: [
      {
        key: "binIcon",
        label: "",
      },
      {
        key: "changePosition",
        label: "",
      },
      {
        key: "primaryConstractor",
        label: i18n.tc("table.subHeading.primaryContractor"),
        thClass: "table-col-header",
      },
      {
        key: "subContractor",
        label: i18n.tc("table.subHeading.subContractor"),
      },
      { key: "workType", label: i18n.tc("table.subHeading.workType") },
      {
        key: "workDescription",
        label: i18n.tc("table.subHeading.workDescription"),
      },
      { key: "sign", label: i18n.tc("table.subHeading.sign") },
      {
        key: "qualificatedResponsible.qualification",
        label: i18n.tc("table.subHeading.qualification"),
      },
      {
        key: "qualificatedResponsible.name",
        label: i18n.tc("table.subHeading.fullName"),
      },
      {
        key: "numberOfPeople.budget",
        label: i18n.tc("table.subHeading.planNumOfPeople"),
        thClass: "border-top-0",
      },
      {
        key: "numberOfPeople.actual",
        label: i18n.tc("table.subHeading.performanceNumOfPeople"),
        thClass: "border-top-0",
      },
      {
        key: "equipments",
        label: i18n.tc("table.subHeading.material"),
      },
      {
        key: "safetyInstructionsType",
        label: i18n.tc("table.subHeading.item"),
      },
      {
        key: "safetyInstructionsInstruction",
        label: i18n.tc("table.subHeading.holdUpMeeting"),
        thClass: "border-top-0 hold-up-meeting",
      },
      {
        key: "confirmed",
        label: i18n.tc("table.subHeading.verification"),
        thClass: "border-top-0",
      },
    ],
  },
  co2Modal: {
    machineTypeOption: [
      {
        key: "wasteRelated",
        value: "廃棄物関連",
      },
      {
        key: "contructionSoil",
        value: "建設発生土分",
      },
    ],
    inSiteWorkFields: [
      {
        key: "inSiteWork.machineOwner",
        label: i18n.tc("co2Modal.inSiteWork.machineOwner"),
      },
      {
        key: "inSiteWork.machine",
        label: i18n.tc("co2Modal.inSiteWork.machine"),
      },
      {
        key: "",
        label: "",
      },
      {
        key: "inSiteWork.budget.number",
        label: i18n.tc("co2Modal.inSiteWork.number"),
      },
      {
        key: "inSiteWork.budge.operatingTime.operationTime",
        label: i18n.tc("co2Modal.inSiteWork.operationTime"),
      },
      {
        key: "inSiteWork.budge.operatingTime.totalTime",
        label: i18n.tc("co2Modal.inSiteWork.totalTime"),
      },
      {
        key: "",
        label: "",
      },
    ],
    diaryInSiteWorkFields: [
      {
        key: "inSiteWork.machineOwner",
        label: i18n.tc("co2Modal.inSiteWork.machineOwner"),
      },
      {
        key: "inSiteWork.machine",
        label: i18n.tc("co2Modal.inSiteWork.machine"),
      },
      {
        key: "inSiteWork.budget.number",
        label: i18n.tc("co2Modal.inSiteWork.number"),
      },
      {
        key: "inSiteWork.budge.operatingTime.operationTime",
        label: i18n.tc("co2Modal.inSiteWork.operationTime"),
      },
      {
        key: "inSiteWork.budge.operatingTime.totalTime",
        label: i18n.tc("co2Modal.inSiteWork.totalTime"),
      },
      {
        key: "",
        label: "",
      },
    ],
    outSiteWorkFields: [
      {
        key: "outSiteWork.machineType",
        label: i18n.tc("co2Modal.outSiteWork.machineType"),
      },
      {
        key: "outSiteWork.number",
        label: i18n.tc("co2Modal.outSiteWork.number"),
      },
      {
        key: "outSiteWork.loadCapacity",
        label: i18n.tc("co2Modal.outSiteWork.loadCapacity"),
      },
      {
        key: "outSiteWork.loadCapacityTrash",
        label: i18n.tc("co2Modal.outSiteWork.loadCapacityTrash"),
      },
      {
        key: "outSiteWork.transportDistance",
        label: i18n.tc("co2Modal.outSiteWork.transportDistance"),
      },
      {
        key: "",
        label: "",
      },
    ],
    outSiteWorkWasteFields: [
      {
        key: "outSiteWork.number",
        label: i18n.tc("co2Modal.outSiteWorkWaste.number"),
      },
      {
        key: "outSiteWork.loadCapacity",
        label: i18n.tc("co2Modal.outSiteWorkWaste.loadCapacity"),
      },
      {
        key: "outSiteWork.transportDistance",
        label: i18n.tc("co2Modal.outSiteWorkWaste.transportDistance"),
      },
      {
        key: "",
        label: "",
      },
    ],
    outSiteWorkContructionSoilFields: [
      {
        key: "outSiteWork.number",
        label: i18n.tc("co2Modal.outSiteWorkContructionSoil.number"),
      },
      {
        key: "outSiteWork.loadCapacity",
        label: i18n.tc("co2Modal.outSiteWorkContructionSoil.loadCapacityTrash"),
      },
      {
        key: "outSiteWork.loadCapacityTrash",
        label: i18n.tc("co2Modal.outSiteWorkContructionSoil.transportDistance"),
      },
      {
        key: "",
        label: "",
      },
    ],
    loadCapacityRecords: [
      { key: "undefined", value: "" },
      { key: "4t", value: "4t車" },
      { key: "10t", value: "10t車" },
    ],
  },
  carryingIORecords: {
    carryFields: [
      {
        key: "inOut",
        label: i18n.tc("carryTable.subHeading.inOut"),
      },
      {
        key: "estimatedTime",
        label: i18n.tc("carryTable.subHeading.estimatedTime"),
      },
      { key: "itemType", label: i18n.tc("carryTable.subHeading.itemType") },
      {
        key: "loadCapacity",
        label: i18n.tc("carryTable.subHeading.loadCapacity"),
      },
      {
        key: "number",
        label: i18n.tc("carryTable.subHeading.number"),
      },
      { key: "memo", label: i18n.tc("carryTable.subHeading.memo") },
      { key: "binIcon", label: "" },
    ],
    inOutFields: [
      {
        key: i18n.tc("carryTable.inOutFields.in"),
        value: i18n.tc("carryTable.inOutFields.in"),
      }, //in
      {
        key: i18n.tc("carryTable.inOutFields.out"),
        value: i18n.tc("carryTable.inOutFields.out"),
      }, //out
    ],
    estimatedTimeFields: [
      { key: null, value: "---" },
      {
        key: "wholeDay",
        value: i18n.tc("carryTable.estimatedTimeFields.wholeDay"),
      },
      { key: "am", value: i18n.tc("carryTable.estimatedTimeFields.am") },
      { key: "pm", value: i18n.tc("carryTable.estimatedTimeFields.pm") },
    ],
  },
  commonInstructions: {
    borderHeaderFields: [
      {
        key: "1",
        label: i18n.tc("commonInstructions"),
      },
      {
        key: "2",
        label: i18n.tc("environmentInstructions"),
      },
      {
        key: "3",
        label: i18n.tc("duringWorkGuidance"),
      },
      {
        key: "4",
        label: i18n.tc("supervisiorCorrection"),
      },
    ],
  },
};
